import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  AppBookingWidgetComponent,
  HomeBookingWidgetComponent,
  ModifyBookingWidgetComponent
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { PushPipe } from '@ngrx/component';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AemEffects } from '../data-access/+state/effects/aem.effects';
import { BookWidgetFieldsInitEffects } from '../data-access/+state/effects/book-widget/book-widget-fields-init.effects';
import { BookWidgetFieldsUpdateEffects } from '../data-access/+state/effects/book-widget/book-widget-fields-update.effects';
import { BookWidgetFieldsValidationEffects } from '../data-access/+state/effects/book-widget/book-widget-fields-validation.effects';
import { BookWidgetRecentSearchSelectionEffect } from '../data-access/+state/effects/book-widget/book-widget-recent-search-selection.effects';
import { CatalogApiEffects } from '../data-access/+state/effects/catalog-api.effects';
import { DefaultLookupEffects } from '../data-access/+state/effects/default-lookup.effects';
import { ErrorHandlerEffects } from '../data-access/+state/effects/error-handler.effects';
import { FeatureFlagsEffects } from '../data-access/+state/effects/feature-flags.effects';
import { DefaultLookupSearchEffects } from '../data-access/+state/effects/find-flights/find-flights-cachekey-lookup.effects';
import { FindFlightsInitEffects } from '../data-access/+state/effects/find-flights/find-flights-init.effects';
import { UpdateSearchApiEffects } from '../data-access/+state/effects/find-flights/find-flights-update-search-api.effects';
import { GeoLocationEffects } from '../data-access/+state/effects/geo-location.effects';
import { LoginDashboardEffects } from '../data-access/+state/effects/login-dashboard.effects';
import { PredictiveSearchEffects } from '../data-access/+state/effects/predictive-search.effect';
import { RetrieveSearchEffects } from '../data-access/+state/effects/retrieve-search.effects';
import { SavedSearchEffects } from '../data-access/+state/effects/saved-search.effects';
import { BookWidgetReducers } from '../data-access/+state/reducers';
import { BookWidgetStoreKey } from '../data-access/constants/common.constants';
import { FlightShopComponent } from './flight-shop.component';

@NgModule({
  imports: [
    CommonModule,
    AppBookingWidgetComponent,
    HomeBookingWidgetComponent,
    ModifyBookingWidgetComponent,
    EffectsModule.forFeature([
      AemEffects,
      GeoLocationEffects,
      CatalogApiEffects,
      DefaultLookupEffects,
      RetrieveSearchEffects,
      BookWidgetFieldsInitEffects,
      DefaultLookupSearchEffects,
      FindFlightsInitEffects,
      BookWidgetFieldsUpdateEffects,
      LoginDashboardEffects,
      ErrorHandlerEffects,
      FeatureFlagsEffects,
      SavedSearchEffects,
      BookWidgetRecentSearchSelectionEffect,
      BookWidgetFieldsValidationEffects,
      UpdateSearchApiEffects,
      PredictiveSearchEffects
    ]),
    StoreModule.forFeature(BookWidgetStoreKey, BookWidgetReducers),
    PushPipe
  ],
  declarations: [FlightShopComponent],
  exports: [FlightShopComponent]
})
export class FlightShopModule {}
